<template>

<RealTimeChat/>
</template>

<script>
import RealTimeChat from '../components/RealtimeChat'
export default {
  name: 'Chat',
  components: {
    RealTimeChat
  }
}
</script>
